module.exports = __webpack_public_path__ + "static/media/meeting_point.bf3c41b0.svg";